// extracted by mini-css-extract-plugin
export default {"Accordion":"Accordion-module__Accordion__uD2mrH1"};